import React from 'react';
import { UrlService } from "../../../../core/services/UrlService"
import './hero.scss';
import $ from "jquery";

const Hero: React.FC<any> = ({ bgImage = 'patient-care/h-pylori/banner-hero.png', reducer }) => {
    const [state, dispatch] = reducer;

    const moveToSelfTest = () => {
        $("html, body").animate({ scrollTop: $('.self-test__test').position()?.top - 50 || 0 }, 1000);
    };

    return (
        <section role="img" aria-label="Image Description">
            <div className="self-test__hero" style={UrlService.getLocalImageUrlStyle(bgImage)}>
                <div className="container">
                    <div className="self-test__hero-title-container">
                        <div className="self-test__hero-title">
                            <div className="self-test__hero-title-left">
                                <h1 className="entry-title mb-4"> 幽門螺旋桿菌</h1>
                            </div>
                            <div className="self-test__hero-title-right">
                                <h1 className="entry-title mb-4"> 免費篩查計劃</h1>
                            </div>
                        </div>
                    </div>
                    <div className="self-test__hero-description-container">
                        <div className="self-test__hero-description-container-text">
                            立即完成一分鐘幽門螺旋桿菌風險評估，或可申請由FindDoc 快德香港及阿斯利康（香港）<br></br>藥廠贊助的免費幽門螺旋桿菌吹氣測試！
                        </div>
                    </div>
                    <div className="self-test__hero-button-container">
                        <button className="self-test__button secondary" onClick={() => dispatch({ type: 'change', data: { anchorId: '成因' }}) }>
                            了解更多幽門螺旋桿菌
                        </button>
                        <button className="self-test__button primary" onClick={moveToSelfTest}>
                            立即進行評估
                        </button>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Hero;